import { AIR_STRIKE_OPTIONS, INTENSITIES, MARTIAL_STRUCTURE } from './details';

export default class StateManager {
	constructor(initialState) {
		this.state = initialState;
		this.listeners = new Set();
	}

	subscribe(listener) {
		this.listeners.add(listener);
		return () => this.listeners.delete(listener);
	}

	setState(newState) {
		this.state = { ...this.state, ...newState };
		this.listeners.forEach((listener) => listener(this.state));
	}

	getState() {
		return this.state;
	}
}

export const DEFAULT_APP_STATE = {
	data: [],
	time: -Infinity,
	searchQuery: '',
	intensities: INTENSITIES,
	airStrike: AIR_STRIKE_OPTIONS,
	martialKeys: MARTIAL_STRUCTURE.nemzetiség,
	days: [-Infinity, Infinity],
	tanks: [-Infinity, Infinity],
	victims: [-Infinity, Infinity],
	presentIds: new Set(),
	pastIds: new Set(),
	visibleIds: new Set(),
	id: -1
};

export const appState = new StateManager(DEFAULT_APP_STATE);
